import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps';
import { STORE_MAP } from '@/config/cache/cache-engine';

export default {
    getWorksQualityNorms: {
        useCache: true,
        cacheStorage: STORE_MAP.FULL,
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORMS
    },
    getWorksQualityNorm: {
        useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORM
    },
    createWorksQualityNorm: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].CREATE_WORKS_QUALITY_NORM
    },
    putWorksQualityNorm: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PUT_WORKS_QUALITY_NORM
    },
    patchWorksQualityNorms: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PATCH_WORKS_QUALITY_NORMS
    },
    deleteWorksQualityNorm: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].DELETE_WORKS_QUALITY_NORM
    }

}